module.exports = __webpack_public_path__ + "img/design@2x.1281e5b.jpg";